/**
 * IMPORTANT: If you modify this section also consider modifying the other sections: 
 * -> amplify/backend/function/ImportRecords/src/fragments.js (vehicleFragment)
 */
export const vehicleFragment = /* GraphQL */`
  fragment vehicleFragment on Vehicle {
    id
    group
    name
    vehicle
    type
    vehicleType {
      id
      group
      order
      option
      default
      usedFor
      daysCount
      canBeEdited
      canBeDeleted
      canBeReorder
      createdAt
      updatedAt
    }
    labels {
      items {
        id
        labelId
        createdAt
        label {
          id
          name
          status
        }
      }
    }
    state
    licensePlateExp
    dateStart
    dateEnd
    ownership
    provider
    otherProvider
    category
    vin
    make
    model
    year
    rentalAgreementNumber
    images
    rentalContracts
    accidentReports
    licensePlate
    mileage
    gasCard
    status
    statusReason
    company {
      id
      option
    }
    notes
    parkingSpace {
      id
      group
      order
      option
      default
      usedFor
      daysCount
      canBeEdited
      canBeDeleted
      canBeReorder
      createdAt
      updatedAt
    }
    lastOdometerReadingDate
    accidents {
      items{
        id
      }
      nextToken
    }
    vehicleDamage {
      nextToken
    }
    odometerReadings {
      items{
        id
        accidentDate
      }
      nextToken
    }
    overTenThousandPounds
    customDeliveryVan
    tollPassId
    createdAt
    updatedAt
    device {
      id
      group
      deviceName
      phoneNumber
      carrier
      status
      notes
      createdAt
      updatedAt
    }
  }
`;

/**
 * Associate fragment without conexions
 * IMPORTANT: If you modify this section also consider modifying the other sections: 
 * -> amplify/backend/function/ImportRecords/src/fragments.js (associateFragmentWithoutConnections)
 * -> amplify/backend/function/executeMutation/src/graphql/fragments.js (associateFragmentWithoutConnections)
 */
export const associateFragmentWithoutConnections = /* GraphQL */ `
  fragment associateFragmentWithoutConnections on Staff {
    id
    group
    vehicleType
    transporterId
    firstName
    lastName
    alternateNames
    keyFocusArea
    dob
    gender
    hireDate
    phone
    status
    createdAt
    updatedAt
    email
    dlExpiration
    vehicleReport
    gasCardPin
    hireDate
    receiveTextMessages
    receiveEmailMessages
    pronouns
    isALead
    assignedLead
    hourlyStatus
    hireDate
    terminationDate
    finalCheckIssueDate
    photo
    smsLastMessageTimestamp
    smsLastMessage
    preferredDaysOff
    timesRescuerCounter
    timesRescuedCounter
    scoreCardsFantasticConsecutiveCounter
    scoreCardsFantasticCounter
    nickname
    displayName
    overrideDisplayName
    staffDefaultVehicleId
    staffDefaultVehicle2Id
    staffDefaultVehicle3Id
    notes
    payrollProviderExternalId
  }
`;


/**
 * Associate fragment with conexions
 * IMPORTANT: If you modify this section also consider modifying the other sections: 
 * -> amplify/backend/function/ImportRecords/src/fragments.js (associateFragmentWithConnections)
 * -> amplify/backend/function/executeMutation/src/graphql/fragments.js (associateFragmentWithConnections)
 */
export const associateFragmentWithConnections = /* GraphQL */ `
  fragment associateFragmentWithConnections on Staff {
    id
    # alternateNames
    authorizedToDrive {
      items {
        id
        group
        staff {
          id
        }
        optionCustomList {
          id
          option
          pillColor
        }
      }
      nextToken
    }
    defaultVehicle{
      id
      status
      name
    }
    defaultVehicle2 {
      id
      status
      name
    }
    defaultVehicle3 {
      id
      status
      name
    }
    labels {
      items {
        id
        createdAt
        group
        labelId
        label {
          id
          name
          status
        }
      }
      nextToken
    }
    staffStatusHistory{
      items {
        id
        group
        reason
        date
        previousStatus
        currentStatus
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;


export const associateFragment = associateFragmentWithConnections + associateFragmentWithoutConnections + /* GraphQL */ `
  fragment associateFragment on Staff {
    ...associateFragmentWithConnections
    ...associateFragmentWithoutConnections
  }
`;

export const deviceFragment = /* GraphQL */ `
  fragment deviceFragment on Device {
    id
    group
    deviceName
    phoneNumber
    carrier
    imei
    status
    notes
    vehicle {
        items{
            id
        }
      nextToken
    }
    deviceLastMessage
    deviceLastMessageTimestamp
  }
`;

export const userFragment = /* GraphQL */ `
  fragment userFragment on User {
    id
    group
    cognitoSub
    firstName
    lastName
    phone
    email
    notificationEmailAddress
    notificationSmsNumber
    receiveNotificationInApp
    receiveNotificationByEmail
    receiveNotificationBySms
    badgeCounterPreferences
    emailVerified
    role
    isCreator
    receiveSmsTaskReminders
    receiveEmailTaskReminders
    receiveSmsTaskAssignments
    receiveEmailTaskAssignments
    permissionLogin
    permissionFullAccess
    permissionDocuments
    permissionAccidents
    permissionInjuries
    permissionDrugTests
    permissionDailyRostering
    permissionMessenger
    permissionPerformanceCoaching
    permissionDAManagement
    permissionCustomLists
    permissionManageLabels
    permissionCompanySettingsSchedulingRostering
    permissionVehicleManagement
    permissionTasksReports
    permissionMessageTemplate
    permissionVehiclePhotoLogs
    permissionManageCounselings
    permissionAmazonChromePlugin
    permissionAIChat
    permissionPayrollProvider
    permissionInventoryManagement
    permissionPhoneAutomation
    permissionVehiclePhotoLogReview
    reportsToUserId
    samePersonAsStaffId
    permissionDocumentsScope
    permissionManageCounselingsScope
    permissionAccidentsScope
    permissionInjuriesScope
    permissionDrugTestsScope
    permissionPerformanceCoachingScope
    rolePermissionOverrides
    lastLogin
    userTenantId
    createdAt
  }
`;

/**
 * IMPORTANT: If you modify this section also consider modifying the other sections: 
 * -> amplify/backend/function/ImportRecords/src/fragments.js (optionsCustomListsStaffFragment)
 */
export const optionsCustomListsStaffFragment = /* GraphQL */ `
  fragment optionsCustomListsStaffFragment on OptionsCustomListsStaff{
    id
    group
    optionCustomList {
      id
      group
      customLists {
        id
        group
        type
        listCategory
        listName
        listDisplay
        createdAt
        updatedAt
      }
      order
      option
    }
    createdAt
    updatedAt
    staff {
      id
    }
  }
`;

/**
 * IMPORTANT: If you modify this section also consider modifying the other sections: 
 * -> amplify/backend/function/ProcessPerformanceData/src/fragments.js (infractionFragment)
 */
export const infractionFragment = /* GraphQL */ `
  fragment infractionFragment on Infraction {
    id
    group
    staffId
    infractionType
    date
    type {
      id
      option
    }
    createdFrom
  }
`;

/**
 * IMPORTANT: If you modify this section also consider modifying the other sections: 
 * -> amplify/backend/function/ProcessPerformanceData/src/fragments.js (kudoFragment)
 */
export const kudoFragment = /* GraphQL */ `
  fragment kudoFragment on Kudo {
    id
    group
    staffId
    kudoType
    date
    type {
      id
      option
    }
    createdFrom
  }
`;

export const tenantFragment = /* GraphQL */ `
  fragment tenantFragment on Tenant {
    id
    group
    templateTenantId
    coachingDriverRankRange
    coachingFicoIssue
    coachingFicoKudo
    coachingDcrIssue
    coachingDcrKudo
    coachingDcDpmoIssue
    coachingDcDpmoKudo
    coachingDarIssue
    coachingDarKudo
    coachingDnrIssue
    coachingDnrKudo
    coachingDsbIssue
    coachingDsbKudo
    coachingSwcPodIssue
    coachingSwcPodKudo
    coachingSwcCcIssue
    coachingSwcCcKudo
    coachingSwcScIssue
    coachingSwcScKudo
    coachingSwcAdIssue
    coachingSwcAdKudo
    coachingSeatbeltOffIssue
    coachingSeatbeltOffKudo
    coachingSpeedingEventIssue
    coachingSpeedingEventKudo
    coachingDistractionsRateIssue
    coachingDistractionsRateKudo
    coachingFollowingDistanceRateIssue
    coachingFollowingDistanceRateKudo
    coachingSignSignalViolationsRateIssue
    coachingSignSignalViolationsRateKudo
    coachingConsecutiveTierIssue
    coachingConsecutiveTierKudo
    coachingOverallTierIssue
    coachingOverallTierKudo
    coachingPositiveFeedbackIssue
    coachingPositiveFeedbackKudo
    coachingCdfScoreIssue
    coachingCdfScoreKudo
    coachingDaTierIssue
    coachingDaTierKudo
    coachingDailyFicoIssue
    coachingDailyFicoKudo
    coachingSeatbeltIssue
    coachingSeatbeltKudo
    coachingSseIssue
    coachingSseKudo
    coachingDvcrsIssue
    coachingTraningRemainingIssue
    coachingCameraObstructionIssue
    coachingDriverDistractionIssue
    coachingDriverDrowsinessIssue
    coachingDriverInitiatedIssue
    coachingDriverStarKudo
    coachingFaceMaskComplianceIssue
    coachingFollowingDistanceIssue
    coachingHardAccelerationIssue
    coachingHardBrakingIssue
    coachingHardTurnIssue
    coachingHighGIssue
    coachingLowImpactIssue
    coachingSeatbeltComplianceIssue
    coachingSignViolationsIssue
    coachingSpeedingViolationsIssue
    coachingTrafficLightViolationIssue
    coachingDailyPpsCompliancePercentIssue
    coachingDailyPpsCompliancePercentKudo
    coachingDailyPpsMissingBrakeIssue
    coachingDailyPpsMissingBrakeKudo
    coachingDailyPpsMissingGearIssue
    coachingDailyPpsMissingGearKudo
    coachingUTurnIssue
    coachingWeavingIssue
    coachingDailyComplianceRateIssue
    coachingDailyComplianceRateKudo
    coachingHarshCorneringRateIssue
    coachingHarshCorneringRateKudo
    coachingHarshBrakingRateIssue
    coachingHarshBrakingRateKudo
    coachingCdfDpmoIssue
    coachingCdfDpmoKudo
    coachingPpsCompliancePercentIssue
    coachingPpsCompliancePercentKudo
    coachingPpsBreachesIssue
    coachingPpsBreachesKudo
    coachingDaMishandledPackageIssue
    coachingDaWasUnprofessionalIssue
    coachingDaIgnoreInstructionsIssue
    coachingDeliveredToWrongAddressIssue
    coachingNeverReceivedDeliveryIssue
    coachingReceivedWrongItemIssue
    customerCheckedUserRolesDateTime
    payrollProvider
    ownerUserId
    permissionHeraAi
    permissionVehiclePhotoLogsHeraAi
    featureAccessVehiclePhotoLogsHeraAi
    featureEnabledVehiclePhotoLogsHeraAi
    featureAccessVehiclePhotoLogReview
    featureEnabledVehiclePhotoLogReview
    featureEnabledInventoryManagement
    featureAccessInventoryManagement
    permissionInventoryManagement
    featureAccessRosterChecklist
    featureEnabledRosterChecklist
    permissionRosterChecklist
    featureAccessWirelessSupportSync
    featureEnabledWirelessSupportSync
    permissionWirelessSupportSync
    featureAccessHeraMessenger2
    featureEnabledHeraMessenger2
    permissionHeraMessenger2
    featureAccessAssociateApp
    featureEnabledAssociateApp
    permissionAssociateApp
    featureAccessPhoneAutomation
    featureEnabledPhoneAutomation
    permissionPhoneAutomation
    featureAccessFilesManagement
    featureEnabledFilesManagement
    featureAccessFilesSignatureRequest
    featureEnabledFilesSignatureRequest
    featureAccessAmazonChromePlugin
    featureEnabledAmazonChromePlugin
    permissionAmazonChromePlugin
    featureAccessAIChat
    featureEnabledAIChat
    permissionAIChat

    featureAccessPayrollProvider
    featureEnabledPayrollProvider
    permissionPayrollProvider
    featureAccessSchedulingAndRostering
    featureEnabledSchedulingAndRostering
    permissionSchedulingAndRostering

    defaultCommunicationChannels
    odometerReadingMaxThreshold
    locale
    featureAccessHierarchicalPermissions
    featureEnabledHierarchicalPermissions
    permissionHierarchicalPermissions
  }
`;

export const tenantUpdateFragment = /* GraphQL */ `
  fragment tenantUpdateFragment on Tenant {
    id
    createdAt
    updatedAt
    companyName
    nameLog
    numberOfSeats
    logo
    accidentReport
    workmansComp
    #dispatchNumber
    addressLine1
    addressLine2
    addressCity
    addressState
    addressZip
    group
    zohoCrmAccountRecordId
    originationNumber
    timeZone
    locale
    trialExpDate
    firstInterestDateTime
    firstStartedTrialDateTime
    firstConvertedToPaidDateTime
    firstChurnedDateTime
    accountPremiumStatus
    accountCanceledNotes
    accountCanceledReason
    notes
    costStandard
    costBundle
    costPerformance
    costRostering
    costStaff
    costVehicles
    costMessaging
    customerCheckedUserRolesDateTime
    payrollProvider
    ownerUserId
    discountPercent
    discountFixed
    discountPercentLabel
    discountFixedLabel
    flatMonthlyBillingAmount
    flatMonthlyBillingLabel
    payOutstandingByDate
    permissionHeraAi
    permissionVehiclePhotoLogsHeraAi
    featureAccessVehiclePhotoLogsHeraAi
    featureEnabledVehiclePhotoLogsHeraAi
    featureAccessVehiclePhotoLogReview
    featureEnabledVehiclePhotoLogReview
    featureEnabledInventoryManagement
    featureAccessInventoryManagement
    permissionInventoryManagement
    featureAccessRosterChecklist
    featureEnabledRosterChecklist
    permissionRosterChecklist
    featureAccessWirelessSupportSync
    featureEnabledWirelessSupportSync
    permissionWirelessSupportSync
    featureAccessCustomEmailSending
    featureEnabledCustomEmailSending
    featureAccessHeraMessenger2
    featureEnabledHeraMessenger2
    permissionHeraMessenger2
    featureAccessPhoneAutomation
    featureEnabledPhoneAutomation
    permissionPhoneAutomation
    featureAccessAssociateApp
    featureEnabledAssociateApp
    featureAccessFilesManagement
    featureEnabledFilesManagement
    featureAccessFilesSignatureRequest
    featureEnabledFilesSignatureRequest
    permissionAssociateApp
    featureAccessAmazonChromePlugin
    featureEnabledAmazonChromePlugin
    permissionAmazonChromePlugin
    featureAccessAIChat
    featureEnabledAIChat
    permissionAIChat

    featureAccessPayrollProvider
    featureEnabledPayrollProvider
    permissionPayrollProvider
    featureAccessSchedulingAndRostering
    featureEnabledSchedulingAndRostering
    permissionSchedulingAndRostering

    featureAccessHierarchicalPermissions
    featureEnabledHierarchicalPermissions
    permissionHierarchicalPermissions
    lastPaidPositiveInvoiceLineItemDateTime
    totalNumberOfMonthsPaidByTenant
    lifetimePaymentTotal
    averageMonthlyInvoiceTotal
    isTestingAccount
    calculatedOutstandingBalance
    bundleDeactivationAllowedAt
    performanceDeactivationAllowedAt
    rosteringDeactivationAllowedAt
    staffDeactivationAllowedAt
    vehiclesDeactivationAllowedAt
    automatedCoachingSendTime
    allowLibraryUpload
    coachingCustomMessage
    messageServiceProvider
    OriginationNumberOrderId
    OriginationNumberStatus
    customerStatus
    shortCode
    growSurfParticipantId
    growSurfReferrerEmail
    growSurfReferrerFullName
    growSurfReferredEmail
    growSurfReferredFullName
    growSurfReferralComplete
    growSurfReferredByEmailBackup
    growSurfReferredByFullNameBackup
    growSurfParticipantEmail
    growSurfParticipantFullName
    growSurfParticipantReferralComplete
    stripeCustomerId
    #stripeBillingEmail
    driverReportDayRange
    accountType
    customerType
    customerSubType
    accountCountry
    isTemporaryAccount
    allowParentData
    parentAccountId
    odometerReadingMaxThreshold
    parentAccount{
      id
      zohoCrmAccountRecordId
    }
    defaultCommunicationChannels
  }
`;
/**
 * IMPORTANT: If you modify this section also consider modifying the other sections: 
 * -> amplify/backend/function/ProcessPerformanceData/src/fragments.js (replaceByRouteFragment)
 */
export const replaceByRouteFragment = /* GraphQL */ `
  fragment replaceByRouteFragment on ReplaceByRoute{
    id
    group
    notes
    routeNumber
    status {
      id
      option
      pillColor
    }
    helperStatus
    parkingSpace {
        id
        order
        option
    }
    staging
    standby
    time
    isNotActive
    messageSentTime
    messageSentError
    receivedAnnouncement
    rescued
    createdAt
    updatedAt
    route{
      id
    }
    dailyRoster{
      id
    }
    staff {
      id
      firstName
      lastName
      receiveEmailMessages
      receiveTextMessages
    }
    vehicle{
        id
        name
    }
    device{
        id
        deviceName
        phoneNumber
        status
    }
    replaceByRouteStatusHistory {
      items {
        id
        associateType
        previousStatus {
          id
          option
          pillColor
        }
        currentStatus {
          id
          option
          pillColor
        }
        date
        reason
      }
    }
  }
`;

/**
 * IMPORTANT: If you modify this section also consider modifying the other sections: 
 * -> amplify/backend/function/ProcessPerformanceData/src/fragments.js (routeFragment)
 */
export const routeFragment = replaceByRouteFragment + /* GraphQL */ `
fragment routeFragment on Route{
  id
  routeDailyRosterId
  group
  notes
  routeNumber
  previousStatus
  status {
    id
    option
    pillColor
  }
  helperStatus {
    id
    option
    pillColor
  }
  parkingSpace {
    id
    order
    option
  }
  staging
  standby
  time
  isNotActive
  messageSentTime
  messageSentError
  receivedAnnouncement
  createdAt
  updatedAt
  replaceByRoute (sortDirection: ASC){
    items{
      ...replaceByRouteFragment
    }
  }
  vehicleDamage {
      items {
        id
      }
      nextToken
  }
  staff {
    id
    firstName
    lastName
    status
    receiveEmailMessages
    receiveTextMessages
  }
  helper {
    id
  }
  rescuer{
    id
  }
  rescuers {
    items {
      id
      staff{
        id
      }
    }
  }
  vehicle {
      id
  }
  device {
      id
      phoneNumber
      deviceName
      status
  }
  routeStatusHistory {
    items {
      id
      createdAt
      associateType
      previousStatus {
        id
        option
        pillColor
      }
      currentStatus {
        id
        option
        pillColor
      }
      date
      reason
    }
  }
}
`;

export const dailyRosterFragment = routeFragment + /* GraphQL */ `
fragment dailyRosterFragment on DailyRoster{
    id
    group
    notesDate
    lastStandUpSentTime
    createdAt
    updatedAt
    attachment {
      id
      group
      s3Key
      expirationDate
      contentType
      createdAt
      updatedAt
    }
    route {
      items {
        ...routeFragment
      }
      nextToken
    }
    notes {
      items {
        id
        group
        type
        date
        text
      }
    }
}
`;

export const dailyLogFragment = /* GraphQL */ `
fragment dailyLogFragment on DailyLog {
  id
  group
  type
  date
  createdAt
  notes
  vehicleId
  creationLinkSentDateTime
  dailyLogCreationLinkSentByUserId
  dailyLogCreationLinkAssociateId
  dailyLogTakenByUserId
  dailyLogTakenByAssociateId
  dailyLogRosteredDayId
  dailyLogVehicleId
  dailyLogCreatedByUserId
}`;

export const accidentFragment = /* GraphQL */ `
fragment accidentFragment on Accident {
  id
  group
  accidentDate
  odometerDate
  createdAt
  updatedAt
  odometerReadingVehicle{
    id
  }
}`;

export const messageFragment = /* GraphQL */ `
fragment messageFragment on Message {
  id
  group
  createdAt 
  attachment{
    id
    s3Key
    contentType
  }
  sender {
    id
  }
  isReadBy {
    items {
      userID
    }
  }
  channelType
  staffId
  senderName
  bodyText
  isReadS
  messageRouteId
  messageType
  smsStatus
  smsSendInformation
  deviceId
  deviceAssociateId
  deviceAssociate {
    id
    firstName
    lastName
    displayName
  }
  device {
    id
    deviceName
    deviceLastMessageTimestamp
    deviceLastMessage
  }
  staff{
    id
    status
  }
}`;

export const messageReadStatusFragment = /* GraphQL */ `
  fragment messageReadStatusFragment on MessageReadStatus {
    id
    group
    userID
    staffID
    readUpToDateTime
    createdAt
    updatedAt
  }
`;

export const noteFragment = /* GraphQL */ `
  fragment noteFragment on Note {
    id
    group
    type
    date
    text
    vehiclesMentioned {
      nextToken
    }
    staffMentioned {
      nextToken
    }
    createdAt
    updatedAt
    dailyRoster {
      id
      group
      notesDate
      lastStandUpSentTime
      userId
      creationRoute
      createdAt
      updatedAt
    }
  }
`;

export const userNotificationFragment = /* GraphQL */ `
  fragment userNotificationFragment on UserNotification {
    id
    group
    title
    description
    expirationTTL
    notificationType
    isRead
    payload
    userId
    createdAt
    updatedAt
  }
`;

export const resourceUsageFragment = /* GraphQL */ `
  fragment resourceUsageFragment on ResourceUsage {
    id
    resourceIdentifier
    resourceType
    inUseAsOfDateTime
    userInstanceId
    createdAt
    updatedAt
    user {
      id
      group
      cognitoSub
      firstName
      lastName
    }
  }
`;

export const companyNotificationFragment = /* GraphQL */ `
  fragment companyNotificationFragment on CompanyNotification {
    id
    group
    streamTable
    affectedTable
    message
    expirationTTL
    createdAt
    updatedAt
  }
`;

export const documentFragment = /* GraphQL */ `
fragment documentFragment on Document {
  id
  group
  name
  key
  type
  uploadDate
  notes
  documentDate
  isDocVisibleToAssociate
  documentDailyLogId
  takenByAssociate {
    id
  }
  createdAt
  updatedAt
}`;

export const rosterChecklistSubjectItemFragment = /* GraphQL */ `
    fragment rosterChecklistSubjectItemFragment on RosterChecklistSubjectItem{
        id
        group
        rosterChecklistSubjectId
        rosterChecklistSubject {
            id
            notesDate
            group
            inactive
            staffId
            userId
            rosterChecklistId
            replaceByRouteId
            routeId
            createdAt
            updatedAt
            shortenUrls{
                items{
                    id
                    group
                    shortenId
                    expirationTTL
                    urlToken
                    attachmentId
                    isOpenLink
                    createdAt
                    updatedAt
                }
            }
            sentMessages(sortDirection: DESC){
                items {
                    id
                    bodyText
                    createdAt
                    emailStatus
                    smsStatus
                    smsSendInformation
                    emailSendInformation
                    messageType
                    createdAt
                    updatedAt
                }
            }
        }
        rosterChecklistItemId
        value
        dailyLogId,
        dailyLog{
            id
            vehicleId,
            documents{
            items{
                id
                key
                name
                type
            }
            }
        }
        odometerReadingId
        odometerReading {
          id
          mileage
        }
        createdAt
        updatedAt
    }
`;
